import styled from "styled-components";
import React,{ useState, Suspense, useMemo } from "react";
import LazyLoad from "react-lazyload";

const FooterMessage = styled.div`
  bottom:0;
  left:0;
  right:0;
  text-align: center;
  position: absolute; 
  color: rgb(122, 122, 169);
  margin:2em;
  font-size: 0.8em;
`;

const LazyImage = styled.img`
  max-height:90vh;
  max-width:90vw;
  height:auto;
  width:auto;
  /* @media (min-width: 769) {
    height:60vh;
  }
  @media (max-width: 768) {
    width:95vw;
  }
   */
`;

const LazyInfo = styled.span`
  color:black;
  font-size: 0.7em;
`;

const LazyItem = styled.li`
  color:black;
  /* @media (min-width: 769) {
    height:60vh;
  }
  @media (max-width: 768) {
    width:95vw;
  }
  padding:0px; */
  max-height:90vh;
  /* max-width:90vw; */
  height:auto;
  width:100vw;
  text-align: center;
  margin:0px;
  list-style-type: none;
  padding-top:15px;

`;

const LazyList = styled.ul`
  padding:0px;
  margin:0px;
`;

const fetchUrls = () => {
  let data;
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const requestOptions = {
    method: "GET",
    headers: myHeaders
    // redirect: "follow"
  };

  let promise = fetch("https://token-proxy.ellis-m-ian.workers.dev/", requestOptions)
    .then((response) => response.json())
    .then((json) => (data = json))
    return {
      read() {
        if (!data) {
          throw promise; 
        }
        let i = data.length;
        while (i != 0) {
          let r = Math.floor(Math.random() * i);
          i--;
          [data[i], data[r]] = [data[r], data[i]];
        }
        return data;
      }
    };
}

const urls = fetchUrls();
let drawingsArr;

const UrlComponent = () => {
  let drawings = urls.read();
  console.log(drawings);
  drawingsArr = drawings;
  const listItems = drawings.map((value, index) => 
    <LazyLoad key={index} >
      <LazyItem ><LazyImage loading="lazy" src={value.url}></LazyImage></LazyItem>
      <LazyInfo>By {value.customMetadata.Author}</LazyInfo>
    </LazyLoad>
  ); 
  
  return(listItems);
}

const DrawingClub = () => {
  const [render, setRender] = useState(new Boolean(false));
  function validatePassword() {
    if (document.getElementById('passwordInput').value == 'password1234') {
      localStorage.setItem('passwordValidation','valid');
    }
    else window.alert("That's not the password.  SCRAM!!");
  }

  function removeValidationCookie() {
    localStorage.removeItem('passwordValidation');
    setRender(!render);
  }

  function ianDrawings() {
    // for (let i = 0; i <drawingsArr.length; i++) if (drawingsArr[i].customMetadata.Author != "Ian") drawingsArr.re
    drawingsArr = drawingsArr.filter((drawing) => drawing.customMetadata.Author == "Ian");
    console.log(drawingsArr);
  }

  return(
  <div>
        {localStorage.getItem('passwordValidation') == 'valid' &&
        <div>
          
            {/* <button onClick={removeValidationCookie}>remove</button> */}
            {/* <button onClick={ianDrawings}>ianDrawings</button> */}
          <Suspense fallback={<div color="black">loading</div>}>
            <UrlComponent></UrlComponent>
          </Suspense>
        </div>
      }
      {!localStorage.getItem("passwordValidation") && 
        <form onSubmit={validatePassword}>
          <input type="password" id="passwordInput"/><br/>
          <button type="submit" >Enter password**</button>
        </form>
      }
      {!localStorage.getItem("passwordValidation") && 
            <FooterMessage>**A note to prospective employers: I don't want to make my users create an account or attach go through real authorization.<br/>If you can log in, that's great for you.  I am able to perform actual authorization, I just don't care to do so in this instance.</FooterMessage>
      }
  </div>
)};
  
export default DrawingClub;
